import SETORES from './SETORES';

const ROUTES_SETORES = {
  agronegocio: {
    ...SETORES.A,
    descricao: SETORES.A.setor,
    iconName: 'agro',
    metadata: {
      description: 'Empresas ligadas à produção agropecuária e à cadeia do agronegócio.'
    }
  },
  mineracao: {
    ...SETORES.B,
    descricao: SETORES.B.setor,
    iconName: 'mining',
    metadata: {
      description: 'Empresas de extração, beneficiamento e comercialização de minerais.'
    }
  },
  industria: {
    ...SETORES.C,
    descricao: SETORES.C.setor,
    iconName: 'factory',
    metadata: { description: 'Empresas de produção e transformação de bens industriais.' }
  },
  energia: {
    ...SETORES.D,
    descricao: SETORES.D.setor,
    iconName: 'on_off',
    metadata: { description: 'Empresas de geração, transmissão e distribuição de energia.' }
  },
  'agua-e-esgoto': {
    ...SETORES.E,
    descricao: SETORES.E.setor,
    iconName: 'water',
    metadata: { description: 'Empresas de abastecimento de água, saneamento e esgoto.' }
  },
  construcao: {
    ...SETORES.F,
    descricao: SETORES.F.setor,
    iconName: 'construction',
    metadata: {
      description: 'Empresas de construção civil, infraestrutura e serviços relacionados.'
    }
  },
  comercio: {
    ...SETORES.G,
    descricao: SETORES.G.setor,
    iconName: 'store',
    metadata: { description: 'Empresas de comércio varejista, atacadista e distribuição.' }
  },
  'transporte-e-logistica': {
    ...SETORES.H,
    descricao: SETORES.H.setor,
    iconName: 'truck',
    metadata: { description: 'Empresas de transporte, armazenagem e operações logísticas.' }
  },
  'hotelaria-e-gastromonia': {
    ...SETORES.I,
    descricao: SETORES.I.setor,
    iconName: 'hotel_gastro',
    metadata: { description: 'Empresas de hospedagem, alimentação e serviços de hospitalidade.' }
  },
  'informacao-e-comunicacao': {
    ...SETORES.J,
    descricao: SETORES.J.setor,
    iconName: 'workstation',
    metadata: { description: 'Empresas de tecnologia, telecomunicações, mídia e comunicação.' }
  },
  financeiro: {
    ...SETORES.K,
    descricao: SETORES.K.setor,
    iconName: 'bank_account',
    metadata: { description: 'Bancos, seguradoras e empresas de serviços financeiros.' }
  },
  imovel: {
    ...SETORES.L,
    descricao: SETORES.L.setor,
    iconName: 'townhouse',
    metadata: { description: 'Empresas de compra, venda, locação e administração de imóveis.' }
  },
  'atividade-profissional': {
    ...SETORES.M,
    descricao: SETORES.M.setor,
    iconName: 'brief_case',
    metadata: { description: 'Consultorias e prestadores de serviços técnicos especializados.' }
  },
  servicos: {
    ...SETORES.N,
    descricao: SETORES.N.setor,
    iconName: 'gears',
    metadata: { description: 'Empresas prestadoras de serviços para pessoas e organizações.' }
  },
  publico: {
    ...SETORES.O,
    descricao: SETORES.O.setor,
    iconName: 'public_service',
    metadata: { description: 'Órgãos e empresas ligados à administração e aos serviços públicos.' }
  },
  educacao: {
    ...SETORES.P,
    descricao: SETORES.P.setor,
    iconName: 'graduation_cap',
    metadata: { description: 'Instituições de ensino e empresas de serviços educacionais.' }
  },
  saude: {
    ...SETORES.Q,
    descricao: SETORES.Q.setor,
    iconName: 'hospital',
    metadata: { description: 'Empresas de assistência, produtos e serviços de saúde.' }
  },
  'cultura-e-esporte': {
    ...SETORES.R,
    descricao: SETORES.R.setor,
    iconName: 'sport',
    metadata: { description: 'Empresas de cultura, entretenimento e atividades esportivas.' }
  },
  'outras-atividades-e-servicos': {
    ...SETORES.S,
    descricao: SETORES.S.setor,
    iconName: 'others_activities',
    metadata: { description: 'Atividades e serviços não classificados nos demais setores.' }
  },
  'servicos-domesticos': {
    ...SETORES.T,
    descricao: SETORES.T.setor,
    iconName: 'domestic_service',
    metadata: { description: 'Serviços de apoio doméstico e manutenção residencial.' }
  },
  'organismos-internacionais': {
    ...SETORES.U,
    descricao: SETORES.U.setor,
    iconName: 'earth',
    metadata: { description: 'Organizações internacionais e representações estrangeiras.' }
  }
};

export default ROUTES_SETORES;
